export default function (config, data) {
  var visibleKey = config.visible;
  var negate = false;
  var visibleValue;

  if (visibleKey) {
    if (visibleKey.indexOf('!') > -1) {
      negate = true;
      visibleKey = visibleKey.substring(1);
    }

    visibleValue = data[visibleKey];

    if (!negate) {
      return visibleValue;
    }

    return !visibleValue;
  }

  return true;
}